import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'clinicsFilter', namespaced: true })
export default class ClinicsFilter extends FilterModule {
    constructor(module: ClinicsFilter) {
        super(module);
    }
}
